import { z } from 'zod';
import { ValidationEntrySeverity } from '../../ValidationEntrySeverity';

export const FiniteNumberSchema = z.number().finite();

export const NumericSchema = z.union([
    FiniteNumberSchema,
    z.literal('Infinity'),
    z.literal('-Infinity'),
    z.literal('NaN'),
]);

export type Numeric = z.infer<typeof NumericSchema>;

export const toNumeric = (stringValue: string): Numeric => {
    if (
        stringValue === 'Infinity' ||
        stringValue === '-Infinity' ||
        stringValue === 'NaN'
    ) {
        return stringValue;
    }
    return Number(stringValue);
};

// TODO returns true for null too! is that correct?
export const isNumeric = (
    value: string | Numeric | undefined | null
): value is Numeric => {
    return z
        .union([NumericSchema.nullable(), z.coerce.number().finite()])
        .safeParse(value).success;
};

export const getColor = (severity?: ValidationEntrySeverity) => {
    return (
        severity === ValidationEntrySeverity.FATAL ? 'error'
        : severity === ValidationEntrySeverity.CRITICAL ? 'error'
        : severity === ValidationEntrySeverity.WARNING ? 'warning'
        : severity === ValidationEntrySeverity.NOTE ? 'info'
        : 'primary'
    );
};

export const getColorMantine = (severity?: ValidationEntrySeverity) => {
    return (
        severity === ValidationEntrySeverity.FATAL ?
            'var(--mantine-color-error)'
        : severity === ValidationEntrySeverity.CRITICAL ?
            'var(--mantine-color-error)'
        : severity === ValidationEntrySeverity.WARNING ?
            'var(--mantine-color-warning)'
        : severity === ValidationEntrySeverity.NOTE ?
            'var(--mantine-color-info)'
        :   undefined
    );
};
